
import Vue from "vue";
import AppDownloads from "@/components/login/Downloads.vue";

export default Vue.extend({
	props: {
		xs: [String, Number],
		sm: [String, Number],
		md: [String, Number],
		lg: [String, Number],
		xl: [String, Number],
		step: Number,
		showDownloads: Boolean
	},
	components: {
		AppDownloads
	}
});
